import React, { Component } from 'react'
import Link from '../utils/link'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import Slider from "react-slick"
import { PlayButton } from './icons'

class Gallery extends Component {

  render() {

    let { images, video, project } = this.props

    const settings = {
      infinite: true,
      speed: 600,
      autoplay: true,
      autoplaySpeed: 5000,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      cssEase: 'ease',
      swipe: false,
      focusOnSelect: false,
      adaptiveHeight: true,
      pauseOnHover:true
    }

    return (
      <section className='gallery'>

        <div className='gallery__inner'>

          <div className='gallery__content'>

            <div className='gallery__images'>

              <Slider {...settings}>
              
                { images.map((el, i) => {

                  if (!project) {
                    if ( el.type === 'Floorplan' ) return
                    return (
                      <div className='gallery__slide'>
                        <img className='team__thumbnail' src={el.url} alt='' onClick={() => this.props.openGallery()} />
                        { i === 0 && video && <button className='play-video' onClick={() => this.props.openVideo()}><PlayButton color={`#000000`} /></button> }
                      </div>
                    )
                    } else {
                      return (
                        <div className='gallery__slide'>
                          <img className='team__thumbnail' src={el.localFile?.childImageSharp?.original?.src} alt='' onClick={() => this.props.openGallery()} />
                          { i === 0 && video && <button className='play-video' onClick={() => this.props.openVideo()}><PlayButton color={`#000000`} /></button> }
                        </div>
                      )
                    }
                })}

              </Slider>

            </div>

          </div>

        </div>

      </section>
    )
  }
}

export default Gallery
